import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  root: {
    display: 'grid',
    height: '100%',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
  },
  progress: {
    margin: theme.spacing(2),
  },
});

function CircularIndeterminate(props) {
  const { classes, ...others } = props;
  return (
    <div className={classes.root}>
      <CircularProgress className={classes.progress} {...others} />
    </div>
  );
}

CircularIndeterminate.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(CircularIndeterminate);
